import type { Order } from "../../../../../../../services";
import type { TFunction } from "i18next";

const cellProcessing = (item: Order.Model, t: TFunction): string => {
	const lastReceivedOrder =
		item?.additionalFields?.transfer?.lastReceivedOrder;

	const toValue = item?.closedOrderComments?.[0];
	const comment =
		toValue?.status === "hide_by_transfer"
			? lastReceivedOrder?.closedOrderComments?.[0]
			: toValue;

	const reason = comment?.status
		? t(`order_closed_status.${comment.status}`)
		: "";

	const getClosedBy = (
		comment: Order.Model["closedOrderComments"][0] | undefined,
		t: TFunction,
	) => {
		if (!comment) return "";

		if (comment.dispatcher) return t("order_closed_by.dispatcher");
		if (comment.executor) return t("order_closed_by.executor");
		if (comment.customer) return t("order_closed_by.customer");

		return "";
	};

	const by = getClosedBy(comment, t);

	return `${reason} ${by ? `(${by})` : ""}`.trim();
};

export default cellProcessing;
